import { FC } from "react";
import {
  RaffleHeader,
  RaffleWheel,
  WheelRaffleItemStatus,
} from "entities/wheel-raffle";
import type { Raffle } from "entities/wheel-raffle";
import { useWheelSpin } from "../../model/useWheelSpin";
import { ConditionsSection } from "./ConditionsSection";
import { CreatorPanel } from "./CreatorPanel";
import { ParticipantPanel } from "./ParticipantPanel";
import { PublicWinners } from "./PublicWinners";
import { RafflePeople } from "./RafflePeople";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  raffle: Raffle;
  inviteCode: string | null;
}

// Создатель видит участников и запускает розыгрыш (ручки v1 только для него).
// Остальные — условия и прогресс, а после розыгрыша ещё и победителей.
export const RaffleLayout: FC<Props> = ({ raffle, inviteCode }) => {
  const { isSpinning, isRevealed, wheelState } = useWheelSpin(
    raffle.status === WheelRaffleItemStatus.DRAWN,
  );

  const renderActions = () => {
    if (isSpinning) {
      return <p className={styles.result}>Drawing the winners...</p>;
    }
    return raffle.is_creator ? (
      <CreatorPanel raffle={raffle} />
    ) : (
      <ParticipantPanel
        raffle={raffle}
        isDrawn={isRevealed}
        inviteCode={inviteCode}
      />
    );
  };

  const renderSidePanel = () => {
    if (raffle.is_creator) {
      return (
        // key: после розыгрыша вкладки пересоздаются и открываются победители.
        <RafflePeople
          key={String(isRevealed)}
          raffleId={raffle.id}
          isDrawn={isRevealed}
          participantsCount={raffle.participants_count}
        />
      );
    }
    return isRevealed ? (
      <PublicWinners
        fids={raffle.winner ?? []}
        participantsCount={raffle.participants_count}
      />
    ) : (
      <ConditionsSection raffle={raffle} />
    );
  };

  return (
    <>
      <div className={styles.columns}>
        <section className={styles.panel}>
          <RaffleHeader raffle={raffle} />
          <RaffleWheel state={wheelState} />
          {renderActions()}
        </section>
        <section className={styles.panel}>{renderSidePanel()}</section>
      </div>
      {(raffle.is_creator || isRevealed) && (
        <section className={styles.panel}>
          <ConditionsSection raffle={raffle} />
        </section>
      )}
    </>
  );
};
